<template>
    <div class="video-thumbnail" :class="thumbnailFormat">
        <router-link :to="{name:'Video', params:{year:year, type: type, videoId: video.id}}">

            <span class="video-img-wrap">
                <img class="video-thumbnail-image" :src="getThumbnailUrl(video.youtubeId)" alt="">
                <span v-if="thumbnailFormat == 'video-option'" class="watch-extra"><i class="icon-play-button"></i>Watch scene</span>
            </span>
            <h3 class="video-title">{{video.title}}</h3>
        </router-link>
    </div>
</template>
<script>
    const TOGGLE_LABEL_DEFAULT = "Browse all videos";

    export default {
        name: 'VideoThumbnail',
        data: function () {
            return {
                isActive: false,
                thumbnailUrl: this.getThumbnailUrl
            }
        },
        methods : {
            //YouTube thumbnail format: https://gist.github.com/protrolium/8831763
            getThumbnailUrl: function(youtubeId){
                let format = 'default';

                switch(this.thumbnailFormat){
                    case "video-map":
                        format = 'mqdefault'   
                        break;
                    case "video-option":
                        format = 'hqdefault'   
                        break; 

                }
                let url = 'https://img.youtube.com/vi/' + youtubeId + '/' + format +'.jpg';
                return url;
            }
        },
        props: ['video', 'year', 'type', 'thumbnailFormat']
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/global/VideoThumbnail.vue